import React from 'react';
import {STATE_ACTIVATE, STATE_HOME, STATE_WAITING} from "../constants/default";
import ActivateDevice from "../screens/ActivateDevice";
import Home from "../screens/Home";
import WaitingConfiguration from "../screens/WaitingConfiguration";

const ScreenComponent = ({screen}) => {
    switch (screen) {
        case STATE_ACTIVATE:
            return <ActivateDevice />;
        case STATE_HOME:
            return <Home />;
        case STATE_WAITING:
            return <WaitingConfiguration />;
        default:
            return null;
    }
};

export default ScreenComponent;
